import React from 'react';
import PropTypes from 'prop-types';
import './BoxFooter.scss';

const BoxFooter = ({ children }) => (
  <div className={'box__footer'}>{children}</div>
);

BoxFooter.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default BoxFooter;
